/* eslint-disable no-console */
import React, { memo, useState } from "react";
import classnames from "classnames";
import config from "config";
import { useNetworkStatus } from "Hooks";
import classes from "./NetworkStatusV2.scss";

function NetworkStatusV2({ isOnline, setIsOnline }) {
  const [isSnackbarVisible, setSnackbarVisible] = useState(false);

  const onStatusChangeHandler = newStatus => {
    console.log("onStatusChangeHandler called with online status: ", newStatus);
    setIsOnline(newStatus);
    setSnackbarVisible(true);
  };

  useNetworkStatus({
    url:
      config.env === "development"
        ? "https://ipv4.icanhazip.com/"
        : "/online.json",
    interval: 15000,
    onStatusChange: onStatusChangeHandler,
  });

  if (!isSnackbarVisible) {
    return null;
  }

  return isOnline ? (
    <div
      className={classnames(
        classes.snackbarContainerUp,
        classes.snackbarContainer
      )}
    >
      <div className={classnames(classes.snackbarOnline, classes.snackbar)}>
        <span className={classes.snackbarOnlineText}>
          You&apos;re back online.
        </span>
      </div>
    </div>
  ) : (
    <div
      className={classnames(
        classes.snackbarContainerDown,
        classes.snackbarContainer
      )}
    >
      <div className={classnames(classes.snackbarOffline, classes.snackbar)}>
        <div className={classes.snackbarOfflineText}>
          Trying to connect. You&apos;re currently offline. Your changes will
          not be saved.
        </div>
      </div>
    </div>
  );
}

export default memo(NetworkStatusV2);
